import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

/**
 * Interceptor that adds withCredentials: true to all requests.
 * This is required for cookies to be sent with cross-origin requests.
 */
export const credentialsInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  // Clone the request with credentials enabled
  const credentialsReq = req.clone({
    withCredentials: true,
  });

  return next(credentialsReq);
};

